import { CommonModule } from '@angular/common';
import { SwMassageConfirmComponent } from './sw-massage-confirm/sw-massage-confirm.component';
import { SwSelectComponent } from './sw-select/sw-select.component';
import { SwPagingComponent } from './sw-paging/sw-paging.component';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from 'ng2-ckeditor';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwTreeModule } from './sw-tree/sw-tree.module';

import { SwTreeSelectComponent } from './sw-tree-select/sw-tree-select.component';
import { DragulaModule } from 'ng2-dragula';
import { NgxEchartsModule } from "ngx-echarts";
import { NgModule } from '@angular/core';
// import { SwImgUploadComponent } from './sw-img-upload/sw-img-upload.component';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { SwAutoUploadComponent } from './sw-auto-upload/sw-auto-upload.component';
import { SwMessageModule } from './sw-message/sw-message.module';
import { defineLocale, zhCnLocale } from 'ngx-bootstrap/chronos';
import { GetUserModelService } from '../../serves/public/get-user-model.service';
import { SwTabService } from '../../serves/public/sw-tab.service';
import { BoolStatePipe } from '../../pipes/state-translation/bool-state.pipe';
import { EnableOrDisabledPipe } from '../../pipes/state-translation/enable-or-disabled.pipe';
import { TypePipe } from '../../pipes/state-translation/type.pipe'
import { WhetherPipe } from '../../pipes/state-translation/whether.pipe';
import { ValidatorEmailDirective } from '../../validator/validator-email.directive';
import { ValidatorIdcardDirective } from '../../validator/validator-idcard.directive';
import { ValidatorRepeatDirective } from '../../validator/validator-repeat.directive';
import { ValidatorPhoneDirective } from '../../validator/validator-phone.directive';
import { ValidatorWwwDirective } from '../../validator/validator-www.directive';
import { SwEnterButtonDirective } from '../../directives/sw-enter-button.directive';
import { ValidatorTelephoneDirective } from '../../validator/validator-telephone.directive';
import { SwAlbumDirective } from '../../directives/sw-album.directive';
import { SwDragModalDirective } from '../../directives/sw-drag-modal.directive';
import { SwTableModule } from './sw-table/sw-table.module';
import { SwSelectMultiComponent } from './sw-select-multi/sw-select-multi.component';
import { SwAudioComponent } from './sw-audio/sw-audio.component';
import { SwAudioDirective } from './sw-audio/sw-audio.directive';
import { SwVideoDirective } from './sw-video/sw-video.directive';
import { SwVideoComponent } from './sw-video/sw-video.component';
import { SwModalframeComponent } from './sw-modal-frame/sw-modal-frame.component';
import { QRCodeModule} from 'angular2-qrcode'
import { ValidatorNumberDirective} from '../../validator/validator-number.directive';
import { SwDateComponent } from './sw-date/sw-date.component';
import { SwCheckAttachmentComponent } from './sw-check-attachment/sw-check-attachment.component';
import { DictionaryPipe } from '../../pipes/state-translation/dictionary.pipe';
import { SwUserOrRoleComponent } from './sw-user-or-role/sw-user-or-role.component';
import { SwSimpleCalendarComponent } from './sw-simple-calendar/sw-simple-calendar.component';
import { SwCreateModalComponentService } from '../../serves/sw-create-modal-component.service';
import { ColorPickerModule} from 'ngx-color-picker'
import { ValidatorParameterVerifyDirective } from '../../validator/validator-parameter-verify.directive';
import { ValidatorNameNotationDirective } from '../../validator/validator-name-notation.directive';
import { ValidatorQqDirective } from '../../validator/validator-qq.directive';
import { SelectFilterPipe } from './sw-select/select-filter.pipe';
import { SwTabComponent } from './sw-tabset/sw-tab/sw-tab.component';
import { SwTabsetComponent } from './sw-tabset/sw-tabset.component';
import { AuditStatePipe } from '../../pipes/state-translation/audit-state.pipe';
import { ProcStatePipe } from '../../pipes/state-translation/proc-state.pipe';
import { SwSortQueryComponent } from './sw-advanced/sw-sort-query/sw-sort-query.component';
import { SwDeepSelectComponent } from './sw-advanced/sw-deep-select/sw-deep-select.component';
import { SwConcatSelectComponent } from './sw-advanced/sw-concat-select/sw-concat-select.component';
import { ValidatorEqualDirective } from '../../validator/validator-equal.directive';
import { StringAbbreviationPipe } from '../../pipes/state-translation/string-abbreviation.pipe';
import { SwTablePrintComponent } from './sw-table-print/sw-table-print.component';
import { EssenceNg2PrintModule } from "essence-ng2-print";
import { SwFileUploadComponent } from './sw-file-upload/sw-file-upload.component';
import { SwSelectMultiBoxComponent } from './sw-select-multi/sw-select-multi-box/sw-select-multi-box.component';
import { SwSelectBoxComponent } from './sw-select/sw-select-box/sw-select-box.component';
import { SwTreeSelectBoxComponent } from './sw-tree-select/sw-tree-select-box/sw-tree-select-box.component';
import { SwCheckAttachmentBoxComponent } from './sw-check-attachment/sw-check-attachment-box/sw-check-attachment-box.component';
import { SwViewFileComponent } from './sw-view-file/sw-view-file.component';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as drilldown from 'highcharts/modules/drilldown.src';
import * as exporting from 'highcharts/modules/exporting.src';
import * as offlineExporting from 'highcharts/modules/offline-exporting.src';
import { SwMouseoverTipDirectiveDirective } from '../../directives/sw-mouseover-tip-directive.directive';
import { SwInputUploadComponent } from './sw-input-upload/sw-input-upload.component';
import { SwFileUploadModalComponent } from './sw-file-upload/sw-file-upload-modal/sw-file-upload-modal.component';
import { UEditorModule } from 'ngx-ueditor';
import { FileSizePipe } from '../../pipes/state-translation/file-size.pipe';
import { SwMaskComponent } from './sw-mask/sw-mask.component';
import { SwDebounceClickDirective } from '../../directives/sw-debounce-click.directive';
import { FlowShowAreaPipe } from '../../pipes/state-translation/flow-show-area.pipe';
import { SafeHtmlPipe } from '../../pipes/state-translation/safe-html.pipe';
import { FormatDatePipe } from '../../pipes/state-translation/format-date.pipe';
import { SwRolePositionComponent } from './sw-role-position/sw-role-position.component';
import { wrapAndWeftDirective} from '../../validator/validator-wrapandweft.directive';
import { Ng2GridLayoutModule } from './sw-ng-grid/main.module';
import { SwLinkMultiComponent } from './sw-link-multi/sw-link-multi.component';
import { SwConcatQueryComponent } from './sw-advanced/sw-concat-query/sw-concat-query.component';
import { SwAddressBookComponent } from './sw-address-book/sw-address-book.component';
import { SwGuidedStepsComponent } from './sw-guided-steps/sw-guided-steps.component';
import { ReceiversPipe } from '../../pipes/state-translation/receivers.pipe';
import { DefaultValuePipe } from '../../pipes/state-translation/default-value.pipe';
import { SwDrawerComponent } from './sw-drawer/sw-drawer.component';
import { SwUploadCutBoxComponent } from './sw-auto-upload/sw-upload-cut-box/sw-upload-cut-box.component';
import { SwTimelineComponent } from './sw-timeline/sw-timeline.component';
import { SwCascaderSelectComponent } from './sw-cascader-select/sw-cascader-select.component';
import { SwCascaderSelectBoxComponent } from './sw-cascader-select/sw-cascader-select-box/sw-cascader-select-box.component';
import { SwCascaderComponent } from './sw-cascader/sw-cascader.component';
import { SwTooltipComponent } from './sw-tooltip/sw-tooltip.component';
import { SwSwitchTooltipComponent } from './sw-switch/sw-switch.component';
import { FileUploadTipPipe } from '../../pipes/state-translation/file-upload-tip.pipe';
import { SwFoucsBlurDirective } from '../../directives/sw-foucs-blur.directive';
import { swIntroComponent } from './sw-intro/sw-intro.component';
import { SwPinyinService } from './sw-select/sw-pinyin.service';
import { PinyinFilterPipe } from './sw-select/pinyin-filter.pipe';
import { SwTimebarComponent } from './sw-timebar/sw-timebar.component';
import { AutoUploadTipPipe } from '../../pipes/state-translation/auto-upload-tip.pipe';
import { SwQrCodeComponent } from './sw-qr-code/sw-qr-code.component';
import { SwInputTagsComponent } from './sw-input-tags/sw-input-tags.component';
import { SwInputTagsBoxComponent } from './sw-input-tags/sw-input-tags-box/sw-input-tags-box.component';

import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SwNzDateComponent } from './sw-nz-date/sw-nz-date.component';

import { SwTableExportComponent } from './sw-table-export/sw-table-export.component';

/**  
 * 框架基础控件
 * 
 */

//映入日期控件中文
defineLocale('zh-cn', zhCnLocale);
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    QRCodeModule,
    FileUploadModule,
    ReactiveFormsModule,
    FormsModule,
    CKEditorModule,
    SwTreeModule, 
    SwTableModule,
    ChartModule,
    SwMessageModule,
    ColorPickerModule,
    BsDatepickerModule.forRoot(),
    DragulaModule.forRoot(),
    NgxEchartsModule, 
    EssenceNg2PrintModule,
    UEditorModule.forRoot({
      js:[
        '../../../assets/Scripts/ueditor/ueditor.config.js',
        '../../../assets/Scripts/ueditor/ueditor.all.js'
      ],
      options:{
        UEDITOR_HOME_URL:'../../../assets/Scripts/ueditor/'
      }
    }),
    Ng2GridLayoutModule,
    NgZorroAntdModule
  ],
  providers: [GetUserModelService, SwTabService,SwCreateModalComponentService,  { provide: HIGHCHARTS_MODULES, useFactory: () => [drilldown, exporting, offlineExporting] },SwPinyinService],
  declarations: [
    SwMassageConfirmComponent, BoolStatePipe, EnableOrDisabledPipe, WhetherPipe,TypePipe,SwSortQueryComponent,SwViewFileComponent,SwQrCodeComponent,
    ValidatorEmailDirective, ValidatorIdcardDirective, ValidatorPhoneDirective, SwAudioComponent,DictionaryPipe,FlowShowAreaPipe,AuditStatePipe,ProcStatePipe,
    SwDeepSelectComponent,SwConcatSelectComponent,ValidatorEqualDirective,SwSelectMultiBoxComponent,SwSelectBoxComponent,SwTreeSelectBoxComponent,
    ValidatorRepeatDirective, SwEnterButtonDirective, SwAudioDirective,ValidatorNumberDirective,ValidatorParameterVerifyDirective,
    ValidatorTelephoneDirective, ValidatorWwwDirective, SwVideoDirective,SwSimpleCalendarComponent,ValidatorNameNotationDirective,
    SwAlbumDirective, SwFileUploadComponent, SwAutoUploadComponent, SwDragModalDirective,SwDebounceClickDirective, SwAutoUploadComponent,SwCheckAttachmentBoxComponent,
    SwSelectComponent, SwPagingComponent, SwSelectMultiComponent,SelectFilterPipe,SwTabComponent,SwTabsetComponent,SwTimebarComponent,
    SwTreeSelectComponent, SwModalframeComponent, SwDateComponent,SwVideoComponent,SwCheckAttachmentComponent, wrapAndWeftDirective,
    SwUserOrRoleComponent ,ValidatorQqDirective,StringAbbreviationPipe,SwTablePrintComponent,SwInputUploadComponent,SwMouseoverTipDirectiveDirective,SwFileUploadModalComponent,FileSizePipe,SwMaskComponent, SwRolePositionComponent,SafeHtmlPipe,FormatDatePipe,
    SafeHtmlPipe,FormatDatePipe,SwLinkMultiComponent, SwConcatQueryComponent, SwAddressBookComponent,SwGuidedStepsComponent,ReceiversPipe,DefaultValuePipe,SwDrawerComponent,SwUploadCutBoxComponent,SwTimelineComponent, SwCascaderSelectComponent,
    SwCascaderSelectBoxComponent, SwCascaderComponent,SwTooltipComponent,SwSwitchTooltipComponent,FileUploadTipPipe,SwFoucsBlurDirective,swIntroComponent,PinyinFilterPipe,AutoUploadTipPipe,SwInputTagsComponent,SwInputTagsBoxComponent,SwNzDateComponent,SwTableExportComponent],
  exports: [
    SwMessageModule, SwEnterButtonDirective,ColorPickerModule, ChartModule,SwAudioComponent, SwVideoComponent, SwAudioDirective,QRCodeModule,SwTabComponent,SwSortQueryComponent,
    NgxEchartsModule, BsDatepickerModule, DragulaModule, SwFileUploadComponent,AuditStatePipe, ProcStatePipe, BoolStatePipe, EnableOrDisabledPipe, WhetherPipe,
    TypePipe,ValidatorParameterVerifyDirective,SwDeepSelectComponent,SwConcatSelectComponent,ValidatorWwwDirective, SwPagingComponent,
    SwTableModule,ValidatorPhoneDirective,ValidatorRepeatDirective,ValidatorNumberDirective,ValidatorNameNotationDirective,SwQrCodeComponent,
    SwTreeSelectComponent, SwDragModalDirective,SwDebounceClickDirective, SwMassageConfirmComponent, SwSelectComponent, SwVideoDirective,SwDateComponent,UEditorModule,
    DictionaryPipe,FlowShowAreaPipe,SwTabsetComponent,ValidatorEqualDirective, SwAlbumDirective,SwInputUploadComponent, SwTreeSelectComponent, 
    CKEditorModule, SwAutoUploadComponent,ValidatorTelephoneDirective,SwSimpleCalendarComponent,SwCheckAttachmentComponent,SwTimebarComponent,
    SwSelectMultiComponent, SwTreeModule, SwModalframeComponent,ValidatorIdcardDirective, wrapAndWeftDirective,Ng2GridLayoutModule,
    SwUserOrRoleComponent,ValidatorEmailDirective,ValidatorQqDirective,StringAbbreviationPipe,SwTablePrintComponent,SwMouseoverTipDirectiveDirective,FileSizePipe,SwMaskComponent,SafeHtmlPipe,
    FormatDatePipe,SwRolePositionComponent,SwLinkMultiComponent ,SwConcatQueryComponent, SwAddressBookComponent,SwGuidedStepsComponent,ReceiversPipe,DefaultValuePipe,SwDrawerComponent, SwUploadCutBoxComponent,
    SwTimelineComponent, SwCascaderSelectComponent,SwCascaderSelectBoxComponent, SwCascaderComponent,SwTooltipComponent,SwSwitchTooltipComponent,FileUploadTipPipe,SwFoucsBlurDirective,swIntroComponent,AutoUploadTipPipe,SwInputTagsComponent,SwNzDateComponent,SwTableExportComponent
  ],
  entryComponents: [
    SwModalframeComponent, SwAudioComponent,SwCheckAttachmentBoxComponent,
    SwVideoComponent,SwTablePrintComponent,SwSelectMultiBoxComponent,SwViewFileComponent,
    SwSelectBoxComponent,SwTreeSelectBoxComponent,SwFileUploadModalComponent,SwMassageConfirmComponent,SwMaskComponent, SwAddressBookComponent,SwDrawerComponent, SwUploadCutBoxComponent,SwTimelineComponent,SwCascaderSelectBoxComponent,SwInputTagsBoxComponent,SwTableExportComponent] 
})
export class BasicComponentsModule { 
  //日期控件显示中文
  constructor(private localeConfig: BsLocaleService) {
    localeConfig.use("zh-cn");
  }
}


